import { render, staticRenderFns } from "./repository.vue?vue&type=template&id=79914931&"
import script from "./repository.vue?vue&type=script&lang=js&"
export * from "./repository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports